import { SidebarSection } from "../styles/Sidebar.styled"

export const Sidebar = () =>{

    return <SidebarSection>
        {/* <p>Hello, Dave!</p> */}
        {/* <p>EnergyGPT</p> */}
        {/* <p>AI Agent Dave</p> */}
        {/* <p>Sign out</p> */}
    </SidebarSection>
}